document.addEventListener('DOMContentLoaded', () => {

  const markers = document.querySelectorAll('.map-marker');

  const popup = document.getElementById('map-popup');
  const country = document.getElementById('popup-country');
  const city = document.getElementById('popup-city');
  const description = document.getElementById('popup-description');
  const tag = document.getElementById('popup-tag');

  markers.forEach((marker) => {

    marker.addEventListener('click', () => {

      const dataCountry = marker.dataset.country;
      const dataCity = marker.dataset.city;
      const dataDescription = marker.dataset.description;
      const dataCategory = marker.dataset.category;

      country.textContent = dataCountry;
      city.textContent = dataCity;
      description.textContent = dataDescription;

      if (dataCategory === 'plantation') {
        tag.textContent = 'Plantation';
      } else if (dataCategory === 'artstone') {
        tag.textContent = 'Artstone';
      } else {
        tag.textContent = 'Plantation & Artstone';
      }

      const markerRect = marker.getBoundingClientRect();
      const containerRect = marker.closest('.global-map-container').getBoundingClientRect();

      popup.style.left = `${markerRect.left - containerRect.left + 40}px`;
      popup.style.top = `${markerRect.top - containerRect.top - 20}px`;

      popup.classList.add('active');

    });

  });

});